module.exports = __webpack_public_path__ + "img/tel.931c573d.jpg";